import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface TableState {
  [key: string]: {
    filters: Record<string, any>;
    page: number;
    pageSize: number;
  };
}

const initialState: TableState = {};

const tableSlice = createSlice({
  name: 'table',
  initialState,
  reducers: {
    setTableFilters: (
      state,
      action: PayloadAction<{ tableKey: string; filters: Record<string, any> }>
    ) => {
      const { tableKey, filters } = action.payload;
      if (!state[tableKey]) state[tableKey] = { filters: {}, page: 1, pageSize: 5 };
      state[tableKey].filters = { ...state[tableKey].filters, ...filters };
    },
    setPagination: (
      state,
      action: PayloadAction<{ tableKey: string; page: number; pageSize: number }>
    ) => {
      const { tableKey, page, pageSize } = action.payload;
      if (!state[tableKey]) state[tableKey] = { filters: {}, page: 1, pageSize: 5 };
      state[tableKey].page = page;
      state[tableKey].pageSize = pageSize;
    },
    resetTableState: (state, action: PayloadAction<{ tableKey: string }>) => {
      const { tableKey } = action.payload;
      if (state[tableKey]) {
        if (tableKey === "budget" || tableKey === "actual") {
          state[tableKey] = { filters: {}, page: 0, pageSize: 5 };
        } else {
          state[tableKey] = { filters: {}, page: 1, pageSize: 5 };
        }
      }
    },
  },
});

export const { setTableFilters, setPagination, resetTableState } = tableSlice.actions;
export default tableSlice.reducer;
